import { InjectionToken } from '@angular/core';

export const icWorkingDomain = new InjectionToken('icWorkingDomain');
export const icWorkingDomainFactory = () => (window as any).icWorkingDomain;
